const CODE_MODAL_MIN_COLUMNS = 72;
const CODE_MODAL_MAX_COLUMNS = 128;
const CODE_MODAL_CHAR_WIDTH_PX = 7.4;
const CODE_MODAL_CHROME_WIDTH_PX = 128;

const getVisualColumnCount = (line: string) => {
	return line.replace(/\t/g, "    ").length;
};

export const getCodeModalWidth = (code: string) => {
	const longestLineColumns = Math.max(
		CODE_MODAL_MIN_COLUMNS,
		...code.split(/\r?\n/).map(getVisualColumnCount)
	);
	const targetColumns = Math.min(
		longestLineColumns,
		CODE_MODAL_MAX_COLUMNS
	);
	const widthPx = Math.round(
		targetColumns * CODE_MODAL_CHAR_WIDTH_PX +
			CODE_MODAL_CHROME_WIDTH_PX
	);

	return `min(calc(100vw - 48px), ${widthPx}px)`;
};
